import { useState, useEffect } from 'react';
import * as Actions from 'flex/Actions';
import { useAppSelector } from 'flex/utils';
import { findTakeHasNewScoreLineItem } from './Helper';

const INIT_STATE: AppStatusModal.ApplicationView = {
    application: undefined,
    loading: false,
    users: [],
    pagination: {
        total: 0,
        pageSize: 50,
        current: 1,
        position: ['topRight', 'bottomRight'],
        showSizeChanger: true,
        pageSizeOptions: ['10', '30', '50'],
    }
};

export const useApplicationViewData = (applicationUuid: string) => {
    const [applicationView, setApplicationView] = useState<AppStatusModal.ApplicationView>({ ...INIT_STATE });
    const appsCategoryResult = useAppSelector(state => state.appsCategoryResultConnection);

    useEffect(() => {
        const {
            meta: { status },
            payload: { result: payloadResult },
        } = appsCategoryResult;
        switch (status) {
            case Actions.statusEnum.REQUEST:
            case Actions.statusEnum.LOADING: {
                setApplicationView({
                    ...INIT_STATE,
                    loading: true,
                });
                break;
            }
            case Actions.statusEnum.SUCCESS: {
                const total = payloadResult?.item_count ? payloadResult?.item_count : 0;
                const applications = payloadResult?.items.length !== 0 && payloadResult
                    ? payloadResult.items[0].applications
                    : undefined;
                const application = applications
                    ? applications.find(application => {
                        return application.uuid === applicationUuid;
                    })
                    : undefined;
                const users = payloadResult?.items.map(item => {
                    const takeHasNewScoreLineItem = findTakeHasNewScoreLineItem(
                        item.applications.find((app) => app.uuid === applicationUuid),
                    );

                    const userName = item.first_name !== '' || item.last_name !== '' ?
                        `${item.last_name} ${item.first_name}` :
                        item.login_id;
                    const user = {
                        name: userName,
                        loginId: item.login_id,
                        uuid: item.uuid,
                        resultUrl: item.applications
                            ? item.applications.find(application => application.uuid === applicationUuid)?.result_url ?? ''
                            : undefined,
                        lineItems: takeHasNewScoreLineItem && takeHasNewScoreLineItem.line_items,
                    };
                    return {
                        ...user,
                    }
                })

                setApplicationView({
                    ...applicationView,
                    pagination: {
                        ...applicationView.pagination,
                        total: total
                    },
                    application: application,
                    loading: false,
                    users: users ?? [],
                });
                break;
            }
            case Actions.statusEnum.FAILURE:
            case Actions.statusEnum.ERROR: {
                setApplicationView({ ...INIT_STATE });
                break;
            }
            default: {
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                const _: never = status;
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [appsCategoryResult]);

    return [applicationView] as const;
};